import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { NavbarComponent } from "./navbar.component";
import { FormsModule } from "@angular/forms";
import { MatMenuModule } from "@angular/material/menu";

import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    MatButtonModule,
    FormsModule,
    MatMenuModule,
    MatIconModule,
    MatTooltipModule
  ],
  declarations: [NavbarComponent],
  exports: [NavbarComponent],
})
export class NavbarModule {}
